import styled from 'styled-components';

import { Button as commonButton } from '../../assets/Common/Button.style';

export const Card = styled.div`
  display: flex;
  width: 100%;
  max-width: 535px;
  height: 100%;
  min-height: 317px;
  justify-content: center;
  padding: 15px;
  margin: auto;
  border-radius: 10px;
  border: 1px solid ${(props) => props.theme.border};
  background: ${(props) => props.theme.background};
  box-shadow: 0 3px 10px 0 ${(props) => props.theme.shadow};
`;

export const CardInner = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-grow: 1;
  text-align: center;
`;

export const Header = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  padding: 0 0 15px;

  &:after {
    position: absolute;
    width: auto;
    height: 1px;
    background: ${(props) => props.theme.backgroundLine};
    right: 0;
    left: 0;
    bottom: 0;
    z-index: +1;
    content: '';
  }
`;

export const Content = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
`;

export const ContentInner = styled.div`
  display: inline-block;
`;

export const Title = styled.h2`
  margin-bottom: 12px;
  font-size: 29px;
  font-weight: 700;
  line-height: 1.2;
  cursor: default;
`;

export const Text = styled.p`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.2;
  cursor: default;
`;

export const Footer = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  padding: 15px 0 0 0;

  &:after {
    position: absolute;
    width: auto;
    height: 1px;
    background: ${(props) => props.theme.backgroundLine};
    right: 0;
    left: 0;
    top: 0;
    z-index: +1;
    content: '';
  }
`;

export const Label = styled.span`
  display: inline-flex;
  margin: 0 0 0 7px;
  padding: 8px 11px;
  border-radius: 5px;
  color: ${(props) => props.theme.color};
  background: ${(props) => props.theme.background};
  font-size: 15px;
  font-weight: 700;
  line-height: 1;
  cursor: default;

  &:first-of-type {
    margin-left: 0;
  }
`;

export const Button = styled.button`
  ${commonButton}
  display: inline-flex;
  width: auto;
  min-width: 300px;
`;

export const OptionButton = styled.button`
  ${commonButton}
  margin: 0 0 0 7px;

  &:first-of-type {
    margin-left: 0;
  }
`;

export const OptionButtonIcon = styled.i`
  margin-left: -5px;
  margin-right: 5px;
`;
